import { Tag } from 'antd'

const StatementJobBadge = ({ count }: { count: number }) => (
  <Tag color="blue">Statement · {count} {count === 1 ? 'job' : 'jobs'}</Tag>
)

export default StatementJobBadge
